import moment from "moment";

const KEYWORD_RANK_UPDATE_TIMEOUT_MINUTES = typeof __KEYWORD_RANK_UPDATE_TIMEOUT_MINUTES !== 'undefined' ? __KEYWORD_RANK_UPDATE_TIMEOUT_MINUTES : 10;

export default function(keyword) {
  const isOlderThanTimeout = moment.utc(keyword.rank_update_pending_since).isBefore(moment().subtract(KEYWORD_RANK_UPDATE_TIMEOUT_MINUTES, 'minutes'));
  return !keyword.rank_update_pending_since || isOlderThanTimeout; 
}